/* unplugin-vue-components disabled */import script from "./MoreQuestionComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreQuestionComponents.vue?vue&type=script&setup=true&lang=js"

import "./MoreQuestionComponents.vue?vue&type=style&index=0&id=1b08e3fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b08e3fb"]])

export default __exports__